var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('model-viewer',{staticClass:"disableSwipe",style:({
        width: _vm.width,
        height: _vm.height,
    }),attrs:{"alt":"Product 3D Viewer","src":_vm.src,"environment-image":_vm.environmentImage,"poster":_vm.poster,"shadow-intensity":"1","exposure":"1.0","camera-orbit":"145deg 65deg 4m","camera-target":"-1.0e-08 0.83 -2.0e-07","field-of-view":"45deg","max-field-of-view":"45deg","camera-controls":"","autoplay":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }